export default __webpack_public_path__ + "static/media/29_ChenFull.a3c76f04.png";